import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import {
  addQueueProductKnowledgeCount,
  resetQueueProductKnowledgeCount,
} from '../../../store/emarsys/action';
import { store } from '../../../store';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { dateFormatterEmarsys } from '../../utils/dateFormatter';

export default function eventClickProductKnowledgeDetail(
  title: string,
  breadcrumbs: IBreadcrumbs[],
  releaseDate: string,
  sectionName: string,
  buttonName: string,
  otherValue?: {
    carModel?: string;
    carType?: string;
    productName?: string;
    branchName?: string;
  }
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isProductKnowledgeActive = getFlagValue(FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_DETAIL);
  if (!isFlagActive || !isProductKnowledgeActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: 'product review detail page',
    page_url: window.location.href,
    page_title: title,
    ...(breadcrumbs?.[1]?.name && { menu_cat_lvl1: breadcrumbs[1].name.toLowerCase() }),
    ...(breadcrumbs?.[2]?.name && { menu_cat_lvl2: breadcrumbs[2].name.toLowerCase() }),
    release_date: dateFormatterEmarsys(releaseDate) || '',
    section_name: sectionName,
    button_name: buttonName,
  };

  if (otherValue?.carModel) {
    valueClickAction.car_model = otherValue.carModel;
  }

  if (otherValue?.carType) {
    valueClickAction.car_type = otherValue.carType;
  }

  if (otherValue?.productName) {
    valueClickAction.product_name = otherValue.productName;
  }

  if (otherValue?.branchName) {
    valueClickAction.branch_name = otherValue.branchName;
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (buttonName === 'lihat semua' || buttonName.includes('lainnya')) {
    ScarabQueue.push(['go']);
    store.dispatch(resetQueueProductKnowledgeCount());
  } else {
    store.dispatch(addQueueProductKnowledgeCount());
  }
}
